import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PhxCheckboxModule } from '../checkbox/checkbox.module';
import { PhxIconModule } from '../icon/icon.module';
import { PhxSpinnerModule } from '../spinner/phx-spinner.module';
import { PhxTooltipModule } from '../tooltip/phx-tooltip.module';
import { PhxSelectModule } from '../select/select.module';
import { PhxIconButtonModule } from '../icon-button/phx-icon-button.module';
import { PhxSkeletonModule } from '../skeleton/phx-skeleton.module';
import { PhxTableComponent } from './phx-table.component';
import { PhxTableRowComponent } from './row/phx-table-row.component';
import { PhxTableCellComponent } from './cell/phx-table-cell.component';
import { PhxTablePaginationComponent } from './pagination/phx-table-pagination.component';
import { PhxCellDefDirective } from './cell/phx-cell-def.directive';
import { PhxStickyColDirective } from './cell/phx-sticky-col.directive';
import { PhxGroupHeaderDirective } from './row/phx-group-header.directive';
import { PhxTableColumnCustomizerComponent } from './column-customizer/phx-table-column-customizer.component';
import { PhxTableDynamicHeightDirective } from './phx-table-dynamic-height.directive';
import { PhxModalModule } from '../modal/phx-modal.module';
import { PhxDragAndDropModule } from '../drag-and-drop/phx-drag-and-drop.module';
import { PhxButtonModule } from '../button/phx-button.module';
import { PhxBadgeModule } from '../badge/phx-badge.module';
import { PhxTableCellHeaderComponent } from './cell/cell-header/phx-table-cell-header.component';
import { PhxDividerModule } from '../divider/phx-divider.module';
import { PhxTagModule } from '../tag/phx-tag.module';
import { PhxMenuModule } from '../menu/menu.module';
import { PhxDropdownModule } from '../dropdown/phx-dropdown.module';
import { PhxTranslationsRootModule } from '../../translation/transloco-root.module';
import { PhxPipesModule } from '../pipes/phx-pipes.module';
import { PhxTableCellsModule } from './cell/phx-table-cells.module';

@NgModule({
  declarations: [
    PhxTableComponent,
    PhxTableRowComponent,
    PhxTableCellComponent,
    PhxTableCellHeaderComponent,
    PhxTablePaginationComponent,
    PhxCellDefDirective,
    PhxStickyColDirective,
    PhxGroupHeaderDirective,
    PhxTableColumnCustomizerComponent,
    PhxTableDynamicHeightDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    PhxBadgeModule,
    PhxButtonModule,
    PhxCheckboxModule,
    PhxDividerModule,
    PhxDragAndDropModule,
    PhxDropdownModule,
    PhxIconModule,
    PhxIconButtonModule,
    PhxMenuModule,
    PhxModalModule,
    PhxSelectModule,
    PhxSkeletonModule,
    PhxSpinnerModule,
    PhxTagModule,
    PhxTooltipModule,
    PhxTranslationsRootModule,
    PhxPipesModule,
    PhxTableCellsModule,
  ],
  exports: [
    PhxTableComponent,
    PhxTableRowComponent,
    PhxTableCellComponent,
    PhxTablePaginationComponent,
    PhxCellDefDirective,
    PhxTableDynamicHeightDirective,
    PhxStickyColDirective,
    PhxGroupHeaderDirective,
    PhxTableCellsModule,
  ],
})
export class PhxTableModule {}
